import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x d-flex align-items-center" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "ms-2" }
const _hoisted_5 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClose())),
        class: "d-flex btn btn-lighter align-items-center"
      }, _hoisted_3),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.currentRouteFriendlyName)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ButtonComponent, {
        label: _ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Save_And_Exit')),
        class: "ms-2 btn-success btn-sm py-2",
        disabled: _ctx.$store.state.isSubmitting === true || !_ctx.canSave,
        loading: _ctx.$store.state.isSubmitting === true,
        type: "submit",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.state.isSubmitting === false ? _ctx.handleSubmitAndExit() : '')),
        loaderClass: "light"
      }, null, 8, ["label", "disabled", "loading"])
    ])
  ], 64))
}